/** Bound independent reads without starting an unbounded number of RPC calls. */
export async function mapConcurrent<T, R>(
  items: readonly T[],
  limit: number,
  work: (item: T) => Promise<R>,
): Promise<R[]> {
  if (!Number.isSafeInteger(limit) || limit < 1)
    throw Error("Invalid concurrency");
  const results = new Array<R>(items.length);
  let cursor = 0,
    failed = false;
  await Promise.all(
    Array.from({ length: Math.min(limit, items.length) }, async () => {
      while (!failed && cursor < items.length) {
        const index = cursor++;
        try {
          results[index] = await work(items[index]);
        } catch (error) {
          failed = true;
          throw error;
        }
      }
    }),
  );
  return results;
}
